import styled from 'styled-components';
import navigationItems from '~/common/constants/navigation';
import { NavigationItem } from '~/components/navigations/NavigationItems';
import { Flex } from '~/components/wrappers/Flex';

interface IDesktopSidebar {
  activeTab?: string;
}

const DesktopSidebar = ({ activeTab }: IDesktopSidebar) => {
  return (
    <StyledFlex>
      {navigationItems.map((item) => (
        <NavigationItem
          key={item.title}
          $active={activeTab === item.location}
          displayTitle={item.displayTitle}
          location={item.location}
        />
      ))}
    </StyledFlex>
  );
};

export default DesktopSidebar;

const StyledFlex = styled(Flex)`
  flex-direction: column;
  width: fit-content;
  gap: 0.5rem;
  padding: 0 0 2.5rem 2.5rem;
`;
